import { FocusMonitor } from '@angular/cdk/a11y';
import { ChangeDetectorRef, Component, DoCheck, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Optional, Output, Provider, Self, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { EmployeeClinicPositionService } from '../../api';
import { EmployeeCategory } from '../../enums';
@Component({
  selector: 'app-doctor-select',
  templateUrl: './doctor-select.component.html',
  styleUrls: ['./doctor-select.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DoctorSelectComponent), multi: true }]
})
export class DoctorSelectComponent implements OnInit, OnChanges, DoCheck, OnDestroy, ControlValueAccessor {
  @Input() storageUrl = '';
  private destroy$ = new Subject();
  doctors: any[] = [];
  public valueControl = new FormControl();
  @Output() change = new EventEmitter<any>();
  @Input() label: string;
  @Input() multiple: boolean;
  @Input()
  get value() {
    return this.valueControl.value;
  }
  set value(val) {
    this.valueControl.setValue(val);
    this.onChange(val);
  }

  constructor(private employeeClinicPositionService: EmployeeClinicPositionService, private elementRef: ElementRef<HTMLElement>,
    private cdr: ChangeDetectorRef,
    private focusMonitor: FocusMonitor,
  ) {

  }
  @Input() categories:EmployeeCategory[] = [EmployeeCategory.Doctor];

  onChange(_: any) { }
  ngOnChanges(changes: SimpleChanges): void {
    // throw new Error('Method not implemented.');
  }
  ngDoCheck(): void {
    //throw new Error('Method not implemented.');
  }
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
    this.focusMonitor.stopMonitoring(this.elementRef);
  }
  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error('Method not implemented.');
  }

  ngOnInit(): void {
    this.employeeClinicPositionService.getByFilter({ categories: this.categories }).subscribe({
      next: (r) => {
        this.doctors = r;
      }
    });
    this.valueControl.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(a => {
      this.onChange(a);
      this.change.emit(this.doctors.find(b=>b.id==a));
    })
  }

}
